import { handleActions, createAction } from 'redux-actions';
import { createFormAction } from 'redux-form-saga';
import update from 'immutability-helper';
import mapActions from '@goodwaygroup/react-map-actions';

// Actions
export const actions = mapActions([
    'CREATE_CAPABILITY_GROUP',
    'FETCH_CAPABILITY_GROUP_LIST',
    'FETCH_CAPABILITY_GROUP_LIST_SUCCESS',
    'FETCH_CAPABILITY_GROUP',
    'FETCH_CAPABILITY_GROUP_SUCCESS',
    'UPDATE_CAPABILITY_GROUP',
    'DELETE_CAPABILITY_GROUP',
], 'CAPABILITY_GROUP');

// Action Creators
export const createCapabilityGroupForm = createFormAction(actions.CREATE_CAPABILITY_GROUP);
export const updateCapabilityGroupForm = createFormAction(actions.UPDATE_CAPABILITY_GROUP);
export const fetchList = createAction(actions.FETCH_CAPABILITY_GROUP_LIST);
export const fetchListSuccess = createAction(actions.FETCH_CAPABILITY_GROUP_LIST_SUCCESS);
export const fetchCapabilityGroup = createAction(actions.FETCH_CAPABILITY_GROUP);
export const fetchCapabilityGroupSuccess = createAction(actions.FETCH_CAPABILITY_GROUP_SUCCESS);
export const deleteCapabilityGroup = createAction(actions.DELETE_CAPABILITY_GROUP);

// Reducers
const initialState = {
    list: [],
    listFetched: false,
    capabilityGroup: null
};

export default handleActions({
    [actions.FETCH_CAPABILITY_GROUP_LIST_SUCCESS]: (state, action) => {
        const updatedData = {
            list: { $set: action.payload },
            listFetched: { $set: true }
        };
        return update(state, updatedData);
    },
    [actions.FETCH_CAPABILITY_GROUP_SUCCESS]: (state, action) => {
        const updatedData = {
            capabilityGroup: { $set: action.payload }
        };
        return update(state, updatedData);
    }
}, initialState);



// WEBPACK FOOTER //
// ./src/services/capabilityGroups/duck.js